import {GET_WEATHER_AND_FORECAST} from "../../constants";

export function getWeatherAndForecast(cityName) {
    return {
        type: GET_WEATHER_AND_FORECAST,
        payload: {
            cityName: cityName
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/redux/action_creaters/index.js